<template>
  <fragment>
    <!--<div class="zipcode-identifier">-->
      <zipcode-input :elementName="elementName"
                     :guidId="guidId"
                     :ariaDescribedBy="ariaDescribedBy"
                     :placeHolder="placeHolder"
                     :attributesString="attributesString">
      </zipcode-input>
    <!--</div>-->
  </fragment>
</template>

<script>
import { mapActions } from "vuex";
import ZipCodeIdentifier from "./components/zipCodeIdentifier.vue";
//import Vue from "vue";
//import VueMq from "vue-mq";
  

//Vue.use(VueMq, {
//  breakpoints: {
//    mobile: 678,
//    tablet: 992,
//    desktop: Infinity
//  }
//});

export default {
    data() {
    return {
      elementName: this.ziElementName,
      guidId: this.ziGuidId,
      ariaDescribedBy: this.ziAriaDescribedBy,
      placeHolder: this.ziPlaceHolder,
      attributesString: this.ziAttributesString
    }
  },
    mounted() {
      // need to check for data here so we can remove the timeout
    
  },
  components: {
    "zipcode-input": ZipCodeIdentifier
  },
    methods: {
      ...mapActions([
      ]),
      renderCards() {

      },
    },
  props: {
    ziElementName: String,
    ziGuidId: String,
    ziAriaDescribedBy: String,
    ziPlaceHolder: String,
    ziAttributesString: String
  }
};
</script>
